import angular from 'angular';

export default class Address {
	#$q;

	#NodeService;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.administrative_area_level_1 = null;
		this.administrative_area_level_2 = null;

		/** @type {?string} */
		this.cedex = null;

		/** @type {?(string | any[])} */
		this.country = null;

		/** @type {?string} */
		this.locality = null;

		this.location = {
			lat:  null,
			lng:  null,
			zoom: 17,
		};

		/** @type {?string} */
		this.name = null;

		this.political = null;

		/** @type {?string} */
		this.postal_box = null;

		/** @type {?string} */
		this.postal_code = null;

		/** @type {?string} */
		this.route = null;

		/** @type {?string} */
		this.route2 = null;

		/** @type {?string} */
		this.street_number = null;

		this.#$q = $injector.get('$q');
		this.#NodeService = $injector.get('NodeService');
	}

	async checkCountry() {
		if (typeof this.country === 'string') {
			return this.country;
		}
		if (Array.isArray(this.country)) {
			if (this.country.length === 0) {
				throw new Error('No country');
			}
			else {
				const node = await this.#NodeService.load(this.country[0].kid);
				if (node) {
					return node.getRepre('K_NODE;CODE').value;
				}
			}
		}
		return undefined;
	}

	format() {
		const items = [];
		if (this.route) {
			items.push((`${this.street_number || ''} ${this.route}`).trim());
		}
		if (this.route2) {
			items.push(this.route2);
		}
		if (this.postal_box) {
			items.push(this.postal_box);
		}
		if (this.locality) {
			items.push((`${this.postal_code || ''} ${this.locality || ''} ${this.cedex || ''}`).trim());
		}
		if (items.length === 0 && this.country) {
			items.push(angular.isArray(this.country) && this.country.length === 1 ? this.country[0].name : this.country);
		}

		return items;
	}

	/**
	 * @param {any} address
	 * @returns {Address}
	 */
	set(address) {
		for (const k in address) {
			if (Object.prototype.hasOwnProperty.call(address, k)) {
				// @ts-ignore
				this[k] = address[k];
			}
		}

		return this;
	}

	/**
	 * @param {string} name
	 * @returns {*}
	 */
	parse(name) {
		const deferred = this.#$q.defer();
		if (!name) {
			// @ts-ignore
			// eslint-disable-next-line no-param-reassign
			({ name } = this);
		}

		this.checkCountry()
			.then(country => {
				switch (country) {
				case 'GF':
				case 'GP':
				case 'FR':
				case 'MQ':
				case 'RE':
				case 'YT': {
					const r = /^(?:(\d+(?:\s*(?:[a-z]|(?:bis|ter)))?(?:-\d+)?)[\s,]+)?((all(?:[eé]e)?|av(?:enue)?|b(?:oulevar)?d|clos|cour|ch(?:emin)?|imp(?:asse)?|mail|mont[eé]e|parvis|passage|place|prom(?:enade)?|quai|sq(?:are)?|route|rue(?:lle)?|sentier|voie)\s+[^,]+)(?:[\s,]*(\d{5})?(?:[\s,]+(.+))?)?$/i.exec(name);
					if (r) {
						this.set({
							street_number: r[1],
							route:         r[2],
							postal_code:   r[4],
							locality:      r[5],
						});
					}

					deferred.resolve(this);
					break;
				}

				default: {
					deferred.reject();
					break;
				}
				}
				return deferred;
			})
			.catch(deferred.reject);

		return deferred.promise;
	}

	toString() {
		return this.format().join(', ');
	}
}

const addressService = /* @ngInject */ (
	/** @type {import('angular').auto.IInjectorService} */ $injector,
) => new Address($injector);

/**
 * @ngdoc service
 * @name app.Address
 * @description
 * # Address
 * Factory in the app.
 */
angular.module('app')
	.factory('AddressService', addressService);
